/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : uiSlice.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Redux Slice for UI component state
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : January 28th, 2022
 *
 * @Version      : Version 1.0
 *
 *
 ******************************************************************************/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "stores/GlobalStore";
import {
  IUIState,
  IErrorState,
  IDiscardChangesWarning,
  ISettingsResetWarning,
  IErrorNotification,
} from "models/ui";

const initialState: IUIState = {
  errorNotification: {
    error: null,
  },
  showAccountModal: true,
  discardChangesWarning: {
    showWarningModal: false,
    headerAction: null,
  },
  settingsResetWarning: {
    showSettingsResetWarningModal: false,
    navigateActionData: null,
    navigateAction: null,
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setErrorNotification(
      uiState: IUIState,
      action: PayloadAction<IErrorState | null>
    ) {
      uiState.errorNotification.error = action.payload;
    },
    setShowAccountModal(uiState: IUIState, action: PayloadAction<boolean>) {
      uiState.showAccountModal = action.payload;
    },
    setDiscardChangesWarning(
      uiState: IUIState,
      action: PayloadAction<IDiscardChangesWarning>
    ) {
      uiState.discardChangesWarning = action.payload;
    },
    setSettingsResetWarning(
      uiState: IUIState,
      action: PayloadAction<ISettingsResetWarning>
    ) {
      uiState.settingsResetWarning = action.payload;
    },
  },
});

export const {
  setErrorNotification,
  setShowAccountModal,
  setDiscardChangesWarning,
  setSettingsResetWarning,
} = uiSlice.actions;

export const uiReducer = uiSlice.reducer;

export const selectErrorNotification = (state: RootState): IErrorNotification =>
  state.ui.errorNotification;
export const selectShowAccountModal = (state: RootState): boolean =>
  state.ui.showAccountModal;
export const selectDiscardChangesWarning = (
  state: RootState
): IDiscardChangesWarning => state.ui.discardChangesWarning;
export const selectSettingsResetWarning = (
  state: RootState
): ISettingsResetWarning => state.ui.settingsResetWarning;
